import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_NEUTRAL_SETZEN = '[VeranstaltungenModul] PostAufgabeNeutralSetzen laden';
export const POST_AUFGABE_NEUTRAL_SETZEN_AUSFUEHREN = '[VeranstaltungenModul] PostAufgabeNeutralSetzen ausführen';
export const POST_AUFGABE_NEUTRAL_SETZEN_ERFOLGREICH = '[VeranstaltungenModul] PostAufgabeNeutralSetzen laden erfolgreich';
export const POST_AUFGABE_NEUTRAL_SETZEN_FEHLER = '[VeranstaltungenModul] PostAufgabeNeutralSetzen Ladefehler';
export const POST_AUFGABE_NEUTRAL_SETZEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostAufgabeNeutralSetzen nicht ausgeführt (evtl. Offline)';


export class PostAufgabeNeutralSetzenAction implements Action {
    readonly type = POST_AUFGABE_NEUTRAL_SETZEN;
        constructor(public aufgabeBemerkungRequest: api.AufgabeBemerkungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeNeutralSetzenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_NEUTRAL_SETZEN_AUSFUEHREN;
        constructor(public aufgabeBemerkungRequest: api.AufgabeBemerkungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeNeutralSetzenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_NEUTRAL_SETZEN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeBemerkungRequest: api.AufgabeBemerkungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeNeutralSetzenFehlerAction implements Action {
    readonly type = POST_AUFGABE_NEUTRAL_SETZEN_FEHLER;
        constructor(public payload: any, public aufgabeBemerkungRequest: api.AufgabeBemerkungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeNeutralSetzenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_NEUTRAL_SETZEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandAufgabeNeutralSetzenActions =
    PostAufgabeNeutralSetzenAction
    | PostAufgabeNeutralSetzenAusfuehrenAction
    | PostAufgabeNeutralSetzenErfolgreichAction
    | PostAufgabeNeutralSetzenFehlerAction
    | PostAufgabeNeutralSetzenNichtAusgefuehrtAction
    ;
